/*
  mn-ff-code.js - Friends & Family code experience (AU store). Config + wording: snippets/mn-ff-code.liquid
  Acts only when one of the configured codes is on the cart:
    1. One-time thank-you popup (once per browser per code).
    2. UpCart drawer: hides the free-shipping bar and the multi-buy nudge, shows a
       "standard shipping rates apply" note instead (the code doesn't combine with free shipping or SELLY tiers).
  Never changes prices, discounts or the cart itself.
  Reliability (v3, 9 Oct 2026): the popup only opens on a page the shopper can actually see (not a background
  tab or a page the browser is preloading), and only counts as "seen" once it has been dismissed or on screen
  for 2 seconds. The cart is re-checked shortly after load and whenever the tab comes back into view.
  Recovery (v5, 9 Oct 2026): Shopify's /discount/CODE link attaches the code to the cart, but when the cart app
  (UpCart) or SELLY saves the cart at the same moment, Shopify keeps their version and the code is dropped.
  Reproduced on an emulated Android phone by opening the link straight after adding to cart. The link's cookie
  survives, so whenever the cookie holds the code but the cart doesn't, the script re-applies it via
  /cart/update.js (up to 5 times per page, re-checked after every cart save) and refreshes the drawer.
  It stops doing this once the shopper removes the code on purpose (a cart save or UpCart discount update that
  drops the code sets a "removed" flag; opening the share link again, or re-entering the code, clears it).
  Console helpers: MNFFCode.check()  MNFFCode.show('MNFAMILY40')  MNFFCode.reset()
*/
(function () {
  'use strict';
  if (window.MNFFCode) return;
  if (window.Shopify && window.Shopify.designMode) return; // not inside the theme editor

  var cfgEl = document.getElementById('mn-ff-config');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent || '{}'); } catch (e) { return; }
  var CODES = (CFG.codes || []).map(function (c) { return String(c).trim().toUpperCase(); })
    .filter(function (c) { return !!c; });
  if (!CODES.length) return;

  var SEEN_KEY = 'mnFFSeen:';
  var nativeFetch = window.fetch;
  var state = { code: null, drawer: false, healed: 0 };

  /* ---------- which code is on the cart ---------- */
  function matchCode(v) {
    v = String(v || '').trim().toUpperCase();
    return CODES.indexOf(v) > -1 ? v : null;
  }
  function fromCookie() {
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]*)/);
    if (!m) return null;
    var raw;
    try { raw = decodeURIComponent(m[1]); } catch (e) { raw = m[1]; }
    var parts = raw.split(',');
    for (var i = 0; i < parts.length; i++) { var c = matchCode(parts[i]); if (c) return c; }
    return null;
  }
  function fromCart(cart) {
    var list = (cart && cart.discount_codes) || [];
    for (var i = 0; i < list.length; i++) {
      var c = matchCode(list[i] && list[i].code);
      if (c) return { code: c, applicable: !!list[i].applicable };
    }
    return null;
  }
  function decide(cart) {
    if (!cart) { var ck = fromCookie(); return { code: ck, drawer: !!ck }; } // cart unreadable: fall back to the link cookie
    var hit = fromCart(cart);
    if (!hit) return { code: null, drawer: false };
    // Empty cart: the code is waiting for items. Ineligible-only cart: the code won't apply, so leave the drawer alone.
    return { code: hit.code, drawer: hit.applicable || !cart.item_count };
  }

  /* ---------- recover a code the share link set but the cart lost ---------- */
  var REMOVED_KEY = 'mnFFRemoved:';
  function removedFlag(code) {
    try { return !!window.sessionStorage.getItem(REMOVED_KEY + code); } catch (e) { return !!window['__mnFFRemoved' + code]; }
  }
  function setRemoved(code, on) {
    try {
      if (on) window.sessionStorage.setItem(REMOVED_KEY + code, String(Date.now()));
      else window.sessionStorage.removeItem(REMOVED_KEY + code);
    } catch (e) { window['__mnFFRemoved' + code] = on ? 1 : 0; }
  }
  // A fresh share-link click (/discount/CODE -> redirect) always re-arms recovery.
  function viaShareLink() {
    try {
      var nav = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      return !!(nav && nav.redirectCount > 0);
    } catch (e) { return false; }
  }
  // Watch cart saves made by the theme, UpCart or SELLY. A save that sets the discount list without our
  // code = the shopper removed it (don't put it back). A save that sets it with our code = re-arm.
  function noteDiscountWrite(url, body) {
    if (!body) return;
    var txt = String(body);
    if (!/discount/i.test(txt)) return;
    var list = null;
    try {
      var j = JSON.parse(txt);
      if (/\/cart\/(update|change)/.test(url) && j && Object.prototype.hasOwnProperty.call(j, 'discount')) {
        list = j.discount == null ? [] : (Array.isArray(j.discount) ? j.discount : String(j.discount).split(','));
      } else if (/graphql/.test(url) && j) {
        var ops = Array.isArray(j) ? j : [j];
        for (var k = 0; k < ops.length; k++) {
          var op = ops[k] || {};
          if (/cartDiscountCodesUpdate/.test(String(op.query || '')) && op.variables && op.variables.discountCodes) {
            list = [].concat(op.variables.discountCodes);
          }
        }
      }
    } catch (e) { return; }
    if (!list) return;
    var has = {};
    for (var i = 0; i < list.length; i++) { var c = matchCode(list[i]); if (c) has[c] = true; }
    CODES.forEach(function (c) {
      if (has[c]) setRemoved(c, false);
      else if (state.code === c || fromCookie() === c) setRemoved(c, true);
    });
  }
  var healTries = 0, healing = false;
  function heal(cart) {
    if (!cart || healing || healTries >= 5) return false;
    var ck = fromCookie();
    if (!ck || fromCart(cart) || removedFlag(ck)) return false;
    healTries++;
    healing = true;
    var f = nativeFetch || window.fetch;
    f.call(window, '/cart/update.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: ck })
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (c) {
        healing = false;
        if (c && fromCart(c)) state.healed++;
        try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) {}
        schedule(300);
        setTimeout(function () { schedule(0); }, 2500); // and again, in case another save overlapped this one
      });
    return true;
  }
  if (viaShareLink()) { var ckInit = fromCookie(); if (ckInit) setRemoved(ckInit, false); }

  /* ---------- cart drawer (UpCart renders inside a shadow root) ---------- */
  function cssString(s) {
    return '"' + String(s || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/[\r\n]+/g, ' ') + '"';
  }
  var DRAWER_CSS =
    '.upcart-public-rewards{padding:14px 16px 4px!important}' +
    '.upcart-public-rewards>*{display:none!important}' +
    '.upcart-public-rewards::before{content:' + cssString(CFG.drawerNote) + ';display:block;padding:10px 12px;' +
      'border-radius:4px;background:#fdf0f6;color:#171717;font-size:14px;line-height:1.4;text-align:center}' +
    '[data-mn-cart-nudge]{display:none!important}';
  var PAGE_CSS = 'html.mn-ff-active [data-mn-cart-nudge]{display:none!important}';

  function upcartRoot() {
    var r = window.upcartDocumentOrShadowRoot;
    if (r && typeof r.querySelector === 'function') return r;
    var host = document.getElementById('upCart');
    return (host && host.shadowRoot) || null;
  }
  function applyDrawer() {
    var root = upcartRoot();
    if (!root) return false;
    var st = root.querySelector('#mn-ff-style');
    if (state.drawer && !st) {
      st = document.createElement('style');
      st.id = 'mn-ff-style';
      st.textContent = DRAWER_CSS;
      root.appendChild(st);
    } else if (!state.drawer && st && st.parentNode) {
      st.parentNode.removeChild(st);
    }
    return true;
  }
  function applyPage() {
    if (!document.getElementById('mn-ff-page-css')) {
      var s = document.createElement('style');
      s.id = 'mn-ff-page-css';
      s.textContent = PAGE_CSS;
      document.head.appendChild(s);
    }
    document.documentElement.classList[state.drawer ? 'add' : 'remove']('mn-ff-active');
  }

  /* ---------- thank-you popup ---------- */
  function seen(code) {
    try { return !!window.localStorage.getItem(SEEN_KEY + code); } catch (e) { return !!window['__mnFFSeen' + code]; }
  }
  function markSeen(code) {
    try { window.localStorage.setItem(SEEN_KEY + code, String(Date.now())); } catch (e) { window['__mnFFSeen' + code] = 1; }
  }
  var MODAL_CSS = [
    '.mn-ff{position:fixed;top:0;right:0;bottom:0;left:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:20px;box-sizing:border-box}',
    '.mn-ff *{box-sizing:border-box}',
    '.mn-ff__backdrop{position:absolute;top:0;right:0;bottom:0;left:0;background:rgba(23,23,23,.55);opacity:0;transition:opacity .2s ease}',
    '.mn-ff__card{position:relative;width:100%;max-width:440px;max-height:calc(100vh - 40px);overflow:auto;background:#fff;color:#171717;border-radius:8px;padding:38px 28px 26px;text-align:center;box-shadow:0 18px 50px rgba(0,0,0,.25);transform:translateY(14px);opacity:0;transition:transform .25s ease,opacity .25s ease;outline:none}',
    '.mn-ff--open .mn-ff__backdrop{opacity:1}',
    '.mn-ff--open .mn-ff__card{transform:none;opacity:1}',
    '.mn-ff__close{position:absolute;top:8px;right:8px;width:40px;height:40px;padding:0;border:0;border-radius:50%;background:transparent;color:#171717;font:inherit;font-size:28px;line-height:40px;cursor:pointer}',
    '.mn-ff__close:hover{background:#f4f4f4}',
    '.mn-ff__eyebrow{margin:0 0 10px;font-size:12px;line-height:1.4;letter-spacing:.14em;text-transform:uppercase;font-weight:600;color:#6b6b6b}',
    '.mn-ff__title{margin:0 0 12px;font-family:inherit;font-size:26px;line-height:1.2;font-weight:400;letter-spacing:normal;text-transform:none;color:#313131}',
    '.mn-ff__body{margin:0 0 20px;font-size:15px;line-height:1.55;color:#171717}',
    '.mn-ff__code{display:flex;align-items:center;justify-content:space-between;gap:10px;margin:0 0 18px;padding:10px 10px 10px 16px;border:1.5px dashed #171717;border-radius:6px;background:#fdf0f6}',
    '.mn-ff__code-text{font-size:18px;font-weight:600;letter-spacing:.08em;word-break:break-all;text-align:left}',
    '.mn-ff__copy{flex:none;margin:0;border:1px solid #171717;border-radius:4px;background:#fff;color:#171717;padding:8px 12px;font:inherit;font-size:13px;font-weight:600;line-height:1.2;cursor:pointer}',
    '.mn-ff__cta{display:block;width:100%;margin:0;border:0;border-radius:4px;background:#fdc5dd;color:#171717;padding:14px 18px;font:inherit;font-size:15px;font-weight:600;letter-spacing:.3px;line-height:1.2;cursor:pointer}',
    '.mn-ff__cta:hover{background:#fbb3d2}',
    '.mn-ff__terms{margin:14px 0 0;font-size:12px;line-height:1.5;color:#6b6b6b}',
    '@media (max-width:480px){.mn-ff{align-items:flex-end;padding:0}.mn-ff__card{max-width:none;max-height:92vh;border-radius:14px 14px 0 0;padding:34px 22px calc(22px + env(safe-area-inset-bottom))}.mn-ff__title{font-size:23px}}',
    '@media (prefers-reduced-motion:reduce){.mn-ff__backdrop,.mn-ff__card{transition:none}}'
  ].join('');

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function legacyCopy(t) {
    try {
      var ta = el('textarea');
      ta.value = t; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.top = '-1000px';
      document.body.appendChild(ta); ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) { return false; }
  }

  function show(code) {
    code = matchCode(code) || String(code || '').toUpperCase();
    if (!code || document.getElementById('mn-ff-modal')) return;
    if (!document.getElementById('mn-ff-modal-css')) {
      var s = el('style'); s.id = 'mn-ff-modal-css'; s.textContent = MODAL_CSS;
      document.head.appendChild(s);
    }
    var wrap = el('div', 'mn-ff');
    wrap.id = 'mn-ff-modal';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'mn-ff-title');
    wrap.setAttribute('aria-describedby', 'mn-ff-body');
    var back = el('div', 'mn-ff__backdrop');
    var card = el('div', 'mn-ff__card');
    card.setAttribute('tabindex', '-1');
    var close = el('button', 'mn-ff__close', '\u00d7');
    close.type = 'button'; close.setAttribute('aria-label', 'Close');
    card.appendChild(close);
    if (CFG.eyebrow) card.appendChild(el('p', 'mn-ff__eyebrow', CFG.eyebrow));
    var title = el('h2', 'mn-ff__title', CFG.heading || 'Thank you');
    title.id = 'mn-ff-title';
    card.appendChild(title);
    var body = el('p', 'mn-ff__body', CFG.body || '');
    body.id = 'mn-ff-body';
    card.appendChild(body);
    var codeBox = el('div', 'mn-ff__code');
    codeBox.appendChild(el('span', 'mn-ff__code-text', code));
    var copy = el('button', 'mn-ff__copy', CFG.copyLabel || 'Copy code');
    copy.type = 'button';
    codeBox.appendChild(copy);
    card.appendChild(codeBox);
    var cta = el('button', 'mn-ff__cta', CFG.button || 'Start shopping');
    cta.type = 'button';
    card.appendChild(cta);
    if (CFG.terms) card.appendChild(el('p', 'mn-ff__terms', CFG.terms));
    wrap.appendChild(back);
    wrap.appendChild(card);
    document.body.appendChild(wrap);

    var prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    var lastFocus = document.activeElement;
    var focusables = [close, copy, cta];
    // Counts as seen once dismissed, or after 2 seconds on screen (so a page that is
    // replaced straight away by a redirect doesn't use up the one-time popup).
    var seenTimer = setTimeout(function () { markSeen(code); }, 2000);

    function done() {
      clearTimeout(seenTimer);
      markSeen(code);
      window.removeEventListener('keydown', onKey, true);
      window.removeEventListener('focusin', onFocusIn, true);
      wrap.classList.remove('mn-ff--open');
      document.documentElement.style.overflow = prevOverflow;
      setTimeout(function () { if (wrap.parentNode) wrap.parentNode.removeChild(wrap); }, 260);
      try { if (lastFocus && lastFocus.focus) lastFocus.focus(); } catch (e) {}
    }
    // Escape/Tab belong to the popup while it's open, so the cart drawer underneath doesn't also react
    // (e.g. Escape closing the drawer as well). Window + capture runs before the theme's and UpCart's listeners.
    function swallow(e) {
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); swallow(e); done(); return; }
      if (e.key !== 'Tab') return;
      swallow(e);
      var i = focusables.indexOf(document.activeElement);
      if (e.shiftKey && i <= 0) { e.preventDefault(); focusables[focusables.length - 1].focus(); }
      else if (!e.shiftKey && (i === -1 || i === focusables.length - 1)) { e.preventDefault(); focusables[0].focus(); }
    }
    // Stop the drawer's focus trap (if any) from pulling focus back out of the popup.
    function onFocusIn(e) {
      if (wrap.contains(e.target)) swallow(e);
    }
    close.addEventListener('click', done);
    back.addEventListener('click', done);
    cta.addEventListener('click', done);
    copy.addEventListener('click', function () {
      var ok = function () {
        copy.textContent = CFG.copiedLabel || 'Copied!';
        setTimeout(function () { copy.textContent = CFG.copyLabel || 'Copy code'; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(ok, function () { if (legacyCopy(code)) ok(); });
      } else if (legacyCopy(code)) { ok(); }
    });
    window.addEventListener('keydown', onKey, true);
    window.addEventListener('focusin', onFocusIn, true);
    (window.requestAnimationFrame || setTimeout)(function () {
      wrap.classList.add('mn-ff--open');
      try { card.focus({ preventScroll: true }); } catch (e) { card.focus(); }
    });
  }

  // Only open the popup on a page the shopper can see: not a background tab, and not a page the
  // browser is preloading in the background. Waits until the page is shown instead.
  var waiting = false;
  function showWhenVisible(code) {
    if (waiting) return;
    var hidden = function () { return !!document.prerendering || document.visibilityState === 'hidden'; };
    if (!hidden()) { show(code); return; }
    waiting = true;
    var go = function () {
      if (hidden()) return;
      waiting = false;
      document.removeEventListener('visibilitychange', go);
      document.removeEventListener('prerenderingchange', go);
      schedule(0); // re-read the cart first: it may have changed while hidden
    };
    document.addEventListener('visibilitychange', go);
    document.addEventListener('prerenderingchange', go);
  }

  /* ---------- check the cart whenever it may have changed ---------- */
  function handle(cart) {
    if (heal(cart)) return; // re-applying the code; the cart is re-read when that finishes
    var d = decide(cart);
    state.code = d.code;
    state.drawer = d.drawer;
    applyPage();
    applyDrawer();
    if (d.code && !seen(d.code)) showWhenVisible(d.code);
  }
  var busy = false, again = false, timer = null;
  function check() {
    if (busy) { again = true; return; }
    busy = true;
    var f = nativeFetch || window.fetch;
    f.call(window, '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (cart) {
        busy = false;
        try { handle(cart); } catch (e) {}
        if (again) { again = false; schedule(); }
      });
  }
  function schedule(ms) {
    clearTimeout(timer);
    timer = setTimeout(check, ms == null ? 150 : ms);
  }

  // UpCart's event API (UpCart may finish loading after this script, so keep trying for ~30s)
  var SUBS = ['upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated', 'upcartSubscribeCartOpened',
    'upcartSubscribeAddedToCart', 'upcartSubscribeItemRemoved'];
  var subscribed = false, tries = 0;
  function subscribe() {
    if (subscribed) return true;
    if (typeof window.upcartSubscribeCartUpdated !== 'function') return false;
    SUBS.forEach(function (fn) {
      try { if (typeof window[fn] === 'function') window[fn](function () { schedule(); }); } catch (e) {}
    });
    subscribed = true;
    return true;
  }
  var poll = setInterval(function () {
    var ok = subscribe();
    var mounted = applyDrawer();
    if ((ok && mounted) || ++tries > 60) clearInterval(poll);
  }, 500);

  // Cart changes made by the theme, SELLY or UpCart itself (incl. applying/removing a code in the drawer)
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var p = nativeFetch.apply(this, arguments);
      try {
        var url = String((input && input.url) || input || '');
        var body = (init && typeof init.body === 'string') ? init.body : '';
        if (/\/cart\/(update|change)|graphql/.test(url)) noteDiscountWrite(url, body);
        if (/\/cart\/(add|change|update|clear)|\/discount\//.test(url) ||
            (/graphql/.test(url) && /discount/i.test(body))) {
          p.then(function () { schedule(250); }, function () {});
        }
      } catch (e) {}
      return p;
    };
  }
  // Same for apps that save the cart with XMLHttpRequest
  try {
    var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { try { this.__mnUrl = String(u || ''); } catch (e) {} return xo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (b) {
      try {
        var u = this.__mnUrl || '';
        if (/\/cart\/(update|change)|graphql/.test(u)) noteDiscountWrite(u, typeof b === 'string' ? b : '');
        if (/\/cart\/(add|change|update|clear)|\/discount\/|graphql/.test(u)) this.addEventListener('loadend', function () { schedule(250); });
      } catch (e) {}
      return xs.apply(this, arguments);
    };
  } catch (e) {}
  ['cart:updated', 'cart:change', 'cart:refresh', 'flu:cart:updated', 'flu:cart:item-added'].forEach(function (ev) {
    document.addEventListener(ev, function () { schedule(); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(0); });
  // Coming back to the tab (e.g. after tapping the link in a text message or email app)
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') schedule(0); });

  window.MNFFCode = {
    check: check,
    show: show,
    state: state,
    removed: function (c) { return removedFlag(matchCode(c) || CODES[0]); },
    reset: function () {
      CODES.forEach(function (c) { try { window.localStorage.removeItem(SEEN_KEY + c); } catch (e) {} });
    }
  };
  check();
  // Re-check shortly after load, in case the code reaches the cart a moment after the page opens
  setTimeout(function () { schedule(0); }, 1500);
  setTimeout(function () { schedule(0); }, 4000);
  setTimeout(function () { schedule(0); }, 7000);
  setTimeout(function () { schedule(0); }, 12000);
})();
